class BentoBoxTile extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector(".bento-box__info-toggle");
    this.closeButton = this.querySelector(".bento-box__info-close");

    if (!this.toggleButton) return;

    this.handleToggleClick = () => (this._isOpen ? this.close() : this.open());
    this.handleCloseClick = () => this.close();

    this.handleDocumentClick = (e) => {
      if (this._isOpen && !this.contains(e.target)) {
        this.close({ returnFocus: false });
      }
    };

    this.handleKeyUp = (e) => {
      if (this._isOpen && e.code.toUpperCase() === "ESCAPE") this.close();
    };

    this.toggleButton.addEventListener("click", this.handleToggleClick);
    this.closeButton?.addEventListener("click", this.handleCloseClick);
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  open() {
    this.setAttribute("open", "");
    this.toggleButton.setAttribute("aria-expanded", "true");

    // On mobile the toggle is swapped out for the close button, so focus has
    // to follow it rather than sit on a hidden element.
    if (this.closeButton && !this._isVisible(this.toggleButton)) {
      this.closeButton.focus();
    }
  }

  close({ returnFocus = true } = {}) {
    const hadFocus = this.contains(document.activeElement);

    this.removeAttribute("open");
    this.toggleButton.setAttribute("aria-expanded", "false");

    if (returnFocus && hadFocus) this.toggleButton.focus();
  }

  _isVisible(el) {
    return window.getComputedStyle(el).display !== "none";
  }

  get _isOpen() {
    return this.hasAttribute("open");
  }
}

if (!customElements.get("bento-box-tile")) {
  customElements.define("bento-box-tile", BentoBoxTile);
}
